import { get } from "../../utils/objectHelpers";

$ {
    const imageSize = get(input, "imageSize", 300);
    const isSmall = get(input, "isSmall", false);
    const link = get(input, "action.URL", null);
    const watchIcon = !input.simplified ? get(input, "__search.defaultWatchIconAtCorner", null) : null;
    const eekIcon = get(input, "eekIcon", null);
    const propertyOrdering = get(input, "itemPropertyOrdering.DEFAULT", {});
    const isAjax = get(input, "action.clientPresentationMetadata.ajax") === "true";
    const sid = get(input, "action.trackingList.[0].eventProperty.sid", "");
    let trackingData = get(input, "action.trackingList.[1]", {});
    if (!Object.keys(trackingData).length) {
        trackingData = get(input, "action.trackingList.[0]", {});
    }
    trackingData = JSON.stringify(trackingData);
    propertyOrdering.header = propertyOrdering.header || [["image"], ["title"]];
    if (!propertyOrdering.header.find(it => it.includes("image"))) {
        propertyOrdering.header.unshift(["image"]);
    }
    const hasUrgencySignal =  get(input, "__search.hasUrgencySignal", false);
    const __signal = hasUrgencySignal && input.itemHotness ? {
        ...input.itemHotness,
        status: "time-sensitive"
    } : null;
    if (__signal && !input.simplified) {
        const currentItemHotnessIdx = propertyOrdering.primary.findIndex(it => it.includes("itemHotness"))
        if (currentItemHotnessIdx !== -1) {
            propertyOrdering.primary.splice(currentItemHotnessIdx, 1);
        }
        if (!propertyOrdering.header.find(it => it.includes("__signal"))) {
            propertyOrdering.header.splice(1, 0, ["__signal"]);
        }
    }
}

class {
    // This assumes the ajax buttons are for the Category filter.
    // Update if there's another variation.
    fetchCategoryListings(url) {
        const evt = new CustomEvent('ajax-module-update-event', {
            detail: {
                url: url,
                updateEvent: 'categoryFilterEvent'
            }
        });
        document.dispatchEvent(evt);
    }
}

<article class=`str-item-card ${input.class}`>
    <if(isAjax)>
        <ebay-button on-click("fetchCategoryListings", link)
            class="str-item-card__ajax-button"
            data-track=trackingData
            variant="fake-link">

            <str-ordered-properties
                properties=propertyOrdering
                card={ ...input, __signal }
                sectionName="header"
                imageSize=imageSize
                isSmall=isSmall
            />
        </ebay-button>
    </if>
    <else>
        <${link ? "a" : "span"} href=link _sp=sid data-track=trackingData>
            <str-ordered-properties
                properties=propertyOrdering
                card={ ...input, __signal }
                sectionName="header"
                imageSize=imageSize
                isSmall=isSmall
            />
        </>
    </else>
    <str-ordered-properties
        properties=propertyOrdering
        card=input
        sectionName="primary"
        isSmall=isSmall
    />
    <if(eekIcon || watchIcon)>
        <div class="str-item-card__bottom">
            <if(eekIcon)>
                <str-eek ...eekIcon />
            </if>
            <!-- <if(watchIcon)>
                <str-watch-icon ...watchIcon />
            </if> -->
        </div>
    </if>
</article>
